import { createContext } from 'react';

import { ClientInfoContext as ClientInfoContextProps } from './interfaces';

export const ClientInfoContext = createContext<ClientInfoContextProps>({} as ClientInfoContextProps);
